import axios from "axios";
import {
  server,
  apiUrl,
  apiMeetUrl,
  NOT_CONNECT_NETWORK,
  NETWORK_CONNECTION_MESSAGE,
} from "@/services/constants";
import router from "@/router";
import api from "@/services/api";
import store from "../store";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

axios.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    const userToken = localStorage.getItem(server.TOKEN_KEY);
    const meetSta = localStorage.getItem(server.MEET_STA);
    if (userToken) {
      // config.headers = { "x-access-token": userToken };
       config.headers = {
        "x-access-token": userToken,
        authorization: `Bearer ${userToken}`,
      };
    }
    // console.log("meetSta : " + meetSta);
    // config.url = apiUrl + "/" + config.url;
    if (meetSta == "true") {
      config.url = apiMeetUrl + "/" + config.url;
    } else {
      config.url = apiUrl + "/" + config.url;
    }
    // console.log("httpClient Url: " + config.url);
  }
  config.timeout = 30000; // 30 Second รอเมื่อ server ไม่ตอบสนอง 30วินาที
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (response.status === 401) {
        // return response;
      // api.logoff();
      store.state.loadMenu = false;
       store.dispatch("doLogout");
      router.push("/page-401");
    }
    if (response.status === 400) {
      return response;
    }
    // console.log(JSON.stringify(error, undefined, 2));
    // router.push("/");
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else if (!error.response) {
      return Promise.reject({
        code: NOT_CONNECT_NETWORK,
        message: NETWORK_CONNECTION_MESSAGE,
      });
    }
    return Promise.reject(error);
  }
);

export default axios;